interface EpisodeListProps {
  total: number;
  current: number;
  onChange: (episode: number) => void;
}

export default function EpisodeList({ total, current, onChange }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 lg:flex-wrap lg:overflow-visible">
      {episodes.map((episode) => (
        <button
          key={episode}
          type="button"
          onClick={() => onChange(episode)}
          className={`shrink-0 px-3.5 py-2 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
            episode === current
              ? "bg-primary-500 text-white"
              : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
          }`}
        >
          第 {episode} 集
        </button>
      ))}
    </div>
  );
}